(function ($) {
  function unicefGallery() {
    let $baseGallery = $('.gallery');
    if ($baseGallery.length > 0) {
      $baseGallery.one().before('<div class="unicef-gallery"></div>');

      let $gallery = $('.unicef-gallery');

      $gallery.one().append('<div class="highlight-wrapper"><div class="highlight"></div></div>');

      $('.highlight-wrapper').one().append('<div class="highlight-caption"></div>');

      $gallery.one().append('<div class="thumbs"></div>');

      $baseGallery.find('img').one().each(function () {
        $(this).wrap('<div class="thumb"></div>');

        $(this).parent('.thumb').detach().appendTo('.thumbs');
      });

      $gallery.find($('.thumb')).on('click', function () {
        $(this).addClass('active');
        $(this).siblings().removeClass('active');
        $('.highlight').html($(this).html());
        $('.highlight-caption').text($(this).find('img').attr('alt'));
      });

      $('.thumb:eq(0)').addClass('active');

      $('.highlight').html($('.thumb:eq(0)').html());

      $('.highlight-caption').text($('.thumb:eq(0)').find('img').attr('alt'));

      $baseGallery.remove();
    };
  };

  $(function () {
    //Calling function after Page Load
    unicefGallery();
  });

}(jQuery));
